import { useMemo } from "react";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import CustomTag from "./CustomTag";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import AlertTypeId from "src/consts/AlertTypeId";
import React from "react";
import EventType from "src/consts/EventType";

interface GrainTempLimitTagProps{
    binDto: PremierPlusBinDTO | null | undefined;
}

const GrainTempLimitTag : React.FC<GrainTempLimitTagProps> = ({ binDto }) => {
    const grainTempLimitTripped = useMemo(() => {
        return binDto?.activeAlerts?.some(a => a.eventType === EventType.GrainOverTemp) ?? false;
    }, [binDto]);
    
    return(
        <CustomTag 
        label={grainTempLimitTripped ? "Grain-temp limit NOT OK" : "Grain-temp limit OK"}
        icon={grainTempLimitTripped ? <CloseCircleFilled /> : <CheckCircleFilled />}
        color={grainTempLimitTripped ? "red" : "green"}
        />
    )
}

export default GrainTempLimitTag;